import { useEffect, useState } from 'react';
import { getYoutubeData } from './index';

export interface IYoutube {
  title: string;
  description: string;
  preview: string;
}

export const useYoutubeData = (url?: string): IYoutube | null => {
  const [youtubeData, setYoutubeData] = useState<IYoutube | null>(null);

  useEffect(() => {
    if (!youtubeData && url) {
      getYoutubeData(url).then((res) => {
        const details = res.response?.data?.items?.[0]?.snippet;

        setYoutubeData({
          title: details?.title,
          description: details?.description,
          preview: details?.thumbnails.high.url,
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  return youtubeData;
};
